<template>
    <div class="project-list-filters / flex">
        <div class="project-list-filters_wrapper">
            <FiltersDisplayHandler />
        </div>
        <div class="project-list-filters_search / flex">
            <VJoyInput
                icon="search"
                :placeholder="t('projectclient.projectlist.topbar.placeholder.search')"
                name="search"
                size="small"
                :model-value="searchParams.query"
                @update:model-value="debouncedSearch"
            />
            <VJoySpinner v-if="loading" />
        </div>
    </div>
</template>

<script setup lang="ts">
    import {useProjectsListStore} from '@features/projects-list';
    import debounce from 'lodash-es/debounce';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import {VJoyInput, VJoySpinner} from '@maltjoy/core-vue';
    import {FiltersDisplayHandler} from './filters';

    const {t} = useTranslation();

    const projectListStore = useProjectsListStore();
    const {searchParams, loading} = storeToRefs(projectListStore);

    const debouncedSearch = debounce((val: string) => {
        searchParams.value.query = val;
    }, 200);
</script>

<style lang="scss" scoped>
    .project-list-filters {
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: center;
        padding: var(--joy-core-spacing-3) var(--joy-core-spacing-4);
        background-color: var(--joy-color-background-default);
        border-radius: var(--joy-core-radius-3) var(--joy-core-radius-3) 0 0;
        flex: 0 0 auto;
        column-gap: var(--joy-core-spacing-2);

        :deep(.joy-input--wrapper) {
            margin-bottom: 0 !important;
        }

        &_search {
            :deep(.joy-spinner) {
                --spinner-size: 22px;

                position: absolute;
                right: var(--joy-core-spacing-3);
                top: 10px;
                z-index: 10;
            }
        }
    }
</style>
